import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Button,
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import Http from 'services/http2';
import CropFreeIcon from '@material-ui/icons/CropFree';
import CommonFns from 'functions/common.ts';

function ProdList(props) {
  const Config = {
    purchase: {
      apiPath: '/archives/compProd/getPageList',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/management/basic-data/prod/detail',
      transObjAuthFlag: true,
      orderProperty: 'prodCode',
      searchBarPlaceholder: '物料编码/名称/规格',
      tabs: ['全部']
      // tabConfig: []
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    handleTab,
    handleChange,
    handleClear,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  useEffect(() => {
    initWx();
  }, []);

  const [wxReady, setWxReady] = useState(false);

  self.beforeSearch = function () {
    self.searchQueries.ascOrDesc = 'asc';
  };

  /** 扫码 begen */

  function initWx() {
    const userAgent = window.navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    //IOS暂不支持扫码
    if (isIOS) {
      return;
    }
    let wx = window.wx;
    let url = window.location.href.split('#')[0];
    Http.post('/api/mp', { url, apiPath: '/initJsapi' }).then(rs => {
      if (rs.success) {
        let data = rs.data;
        if (!data.appId) {
          return;
        }
        wx.config({
          ...data,
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          jsApiList: ['scanQRCode', 'chooseImage', 'getNetworkType'] // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
          setWxReady(true);
        });
        wx.error(function (res) {
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        });
      }
    });
  }

  function scan() {
    let wx = window.wx;

    wx.scanQRCode({
      needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
      success: function (res) {
        //一维码：{reultStr: 'code128,abcd123', errMsg: 'scanQRCode:ok'}
        //二维码：{reultStr: 'abcd123', errMsg: 'scanQRCode:ok'}
        let result = res.resultStr;
        let arrCode = result.split(',');
        let code = arrCode[arrCode.length - 1];
        let url =
          '/mp/management/basic-data/prod/detail/' + companyCode + '/' + code;
        props.history.push(url);
      },
      fail: function (res) {
        alert(JSON.stringify(res));
      }
    });
  }
  /** 扫码 end */

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            {wxReady && (
              <div className="wrap m-flex-box fixed-bottom">
                {
                  <Button
                    type="default"
                    onClick={scan}
                    className="m-flex-item u-btn u-btn_primary"
                  >
                    <CropFreeIcon fontSize="inherit" />
                    扫码查询
                  </Button>
                }
              </div>
            )}
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.prodCode}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>序号{index + 1}</span>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>物料编码</label>
                          <div>{item.prodCode}</div>
                        </li>
                        <li>
                          <label>物料名称</label>
                          <div>{item.prodName}</div>
                        </li>
                        <li>
                          <label>物料规格</label>
                          <div>{item.prodScale}</div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

ProdList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(ProdList);
